import Lookup from 'src/componentes/select2';

const TipoValorFaixa = (props) => {
  return (
    <Lookup
      clearable={false}
      labelKey="descricao"
      valueKey="id"
      url="/TipoValorFaixaLookup"
      {...props}
    />
  );
};

export default TipoValorFaixa;
